import React from 'react'
import Card from 'react-bootstrap/Card'
import { Image } from 'react-bootstrap'
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'
import { useAppSelector } from '../store/hooks'

const InvoiceFileViewerBlock: React.FC = () => {
	const { currentInvoice } = useAppSelector((state) => state.invoices)

	const isPdf = (url: string) => {
		return url.includes('.pdf')
	}

	if (!currentInvoice) {
		return (
			<Card className="h-100 p-1">
				<Card.Body>
					<Card.Title>Оберіть заявку для перегляду</Card.Title>
				</Card.Body>
			</Card>
		)
	}

	return (
		<Card className="h-100 p-1">
			{currentInvoice.sender_email && currentInvoice.saved_letter_body && (
				<Card.Body>
					<Card.Title>Email: {currentInvoice.sender_email}</Card.Title>
					<Card.Text>{currentInvoice.saved_letter_body}</Card.Text>
				</Card.Body>
			)}
			{currentInvoice.file_url &&
				(isPdf(currentInvoice.file_url) ? (
					<>
						<span className="p-1 sm w-75 opacity-50 z-2">
							Для масштабування використовуйте
							<br />
							Ctrl + коліщатко
						</span>
						<div
							style={{ minHeight: '500px' }}
							className="position-relative w-100 h-100"
						>
							<iframe
								src={currentInvoice.file_url}
								width="100%"
								height="100%"
							/>
						</div>
					</>
				) : (
					<div
						style={{ minHeight: '500px' }}
						className="position-relative w-100 h-100"
					>
						<span className="p-1 bg-dark position-absolute sm w-100 opacity-50 z-2">
							Для масштабування використовуйте коліщатко
						</span>
						<TransformWrapper>
							<TransformComponent contentStyle={{ cursor: 'move' }}>
								<Image src={currentInvoice.file_url} fluid />
							</TransformComponent>
						</TransformWrapper>
					</div>
				))}
		</Card>
	)
}

export default InvoiceFileViewerBlock

